import { Stack } from "@mui/joy";
import React, { useEffect, useRef } from "react";
import FullPageContainer from "./FullPageContainer";
import { theme } from "styles/theme";
import useSafeAreaColor from "hooks/useSafeAreaColor";

export default function FullPageWithCenterContentV2({
  backgroundColor = theme.vars.palette.Background.Level1,
  content,
  disableSafeAreaColorSync = false,
}: {
  backgroundColor?: string;
  content: React.ReactNode;
  // 상위에서 safe-area 색을 단일 색으로 고정 관리하는 화면(promotion 퍼널)이
  // 컨테이너의 스텝별 동기화를 끌 때 사용. 페이지 배경 페인트는 그대로 유지.
  disableSafeAreaColorSync?: boolean;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  // 화면 잘림 문제
  useEffect(() => {
    // 페이지 전환(혹은 특정 이벤트) 시점에
    if (containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, []);

  useSafeAreaColor(disableSafeAreaColorSync ? undefined : backgroundColor);

  return (
    <FullPageContainer hasFooter={false} backgroundColor={backgroundColor}>
      <Stack
        ref={containerRef}
        flexGrow={1}
        justifyContent="center"
        sx={{ width: "100%", maxWidth: "500px", mx: "auto", px: "20px" }}
      >
        {content}
      </Stack>
    </FullPageContainer>
  );
}
